const CopyRight = ({ ...props }) => (
  <p {...props}>© Databrydge {new Date().getFullYear()}</p>
);

CopyRight.defaultProps = {};

export default CopyRight;
